import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => ({
  mainContainer: {
    padding: '24px',
    [theme.breakpoints.down('md')]: {
      padding: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '12px',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 1px 5px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.24)',
    position: 'sticky',
    top: '0',
  },
  tableTitle: {
    fontSize: '16px',
    color: '#075782',
    lineHeight: '24px',
    minHeight: '36px',
    padding: '6px 8px',
  },
  tableTitleSummary: {
    fontFamily: 'HP Simplified',
    fontStyle: 'normal',
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.87) !important',
  },
  header: {
    background: 'none !important',
    boxShadow: 'none !important',
    border: '1px solid #e8e8e8',
    borderRadius: '0 4px 4px 0 !important',
    borderLeft: 'none !important',
  },
  title: {
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    color: '#0096D6',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px',
    letterSpacing: '0.15px',
    padding: '4px 0',
    paddingLeft: '16px',
    background: ' linear-gradient(89.96deg, #F7F7F7 64.43%, rgba(196, 196, 196, 0) 106.93%)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      paddingLeft: '10px',
    },
  },
  responsiveContentContainer: {
    display: 'flex',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },

  tableContainer: {
    display: 'flex',
    flex: '1 1',
    flexDirection: 'column',
    padding: '19px 24px 24px',
    width: '80%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '19px 16px 16px',
    },
  },
  dealHistoryTableContainer: {
    position: 'relative',
    overflow: 'auto',
    height: '200px',
    border: '1px solid #e0e0e0',
  },
  tableHeaderTitle: {
    padding: '6px 16px',
    border: '1px solid #E0E0E0',
    borderRadius: '4px 4px 0 0',
    borderBottom: 0,
    fontFamily: 'Segoe UI, Roboto, Helvetica Neue',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '150%',
    letterSpacing: '0.15px',
    color: '#7D3894',
    width: '75%',
  },
  dateFieldsContainer: {
    flex: '0 0 300px',
    minWidth: '400px',
    marginRight: '30px',
    marginTop: '17px',
    [theme.breakpoints.down('md')]: {
      flex: '1 1 auto',
      minWidth: 'unset',
      marginRight: '0',
      marginTop: '20px',
      padding: '0 16px 24px',
      width: '100%',
      maxWidth: '400px',
      alignSelf: 'flex-start',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 16px 16px',
      maxWidth: '100%',
    },
  },
  manageBackUpTableContainer: {
    position: 'relative',
    overflow: 'auto',
    height: '100%',
    border: '1px solid #e0e0e0',
    width: '100%',

    '$.ag-header-row': {
      height: '36px',
    },
    '& .ag-cell.text-left-cell': {
      textAlign: 'left',
    },
    '$.ag-header': {
      height: '36px',
    },

    '$.ag-header-cell-text': {
      height: '36px !important',
    },

    "& div[class^='ag-tabs-header']": {
      display: 'flex !important',
    },

    "& div[class^='ag-cell']": {
      lineHeight: '30px',
      height: '30px',
      textAlign: 'left',
    },

    '&.ag-theme-alpine': {
      '--ag-header-foreground-color': 'black',
      '--ag-header-background-color': 'white',
      '--ag-odd-row-background-color': 'white',
      '--ag-background-color': 'white',
    },

    '&.ag-theme-alpine .highlight-matching-pl': {
      background: 'rgba(248, 250, 184, 0.5)',
    },

    '&.ag-theme-alpine .subtotal-rows': {
      background: '#F5F5F5',
      color: 'rgba(0, 0, 0, 0.87) !important',
    },

    '&.ag-theme-alpine .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value)': {
      height: '30px',
    },

    '& .ag-cell-value': {
      fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
      fontSize: '13px',
      fontWeight: '450',
      fontStyle: 'normal',
    },

    "& div[class^='ag-root']": {
      borderRadius: '0 0 4px 4px',
      borderColor: '#E0E0E0',
      border: 'none',
    },

    "& div[class^='ag-header']": {
      borderColor: '#E0E0E0',
      color: 'rgba(0, 0, 0, 0.54)',
      fontFamily: 'HP Simplified',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      height: '36px !important',
      minHeight: '36px !important',
    },

    "& div[class^='ag-header-cell']": {
      textAlign: 'right',
      paddingLeft: '8px!important',
      paddingRight: '0!important',
      display: 'inline-flex',
      alignItems: 'center',
      // position: 'absolute',
      overflow: 'hidden',
      '& .ag-react-container': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-between',
      },
      '& .customHeaderMenuButtonList': {
        display: 'none',
      },
      '&:hover': {
        '& .customHeaderMenuButtonList': {
          display: 'flex',
          opacity: 1,
        },
      },
    },

    "& div[class^='ag-cell-label-container']": {
      height: '36px !important',
      flexDirection: 'unset',
      paddingRight: '5px',
    },

    "& div[class^='ag-header-cell-label']": {
      height: '36px !important',
      flexDirection: 'row-reverse',
    },

    '&.agGridItemsColumnHeader': {
      justifyContent: 'flex-start',
    },

    "& div[class^='ag-header-cell-text']": {
      marginRight: '3px',
    },
    '& .customHeaderItems': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
      minWidth: '30px',
    },

    '& .customHeaderItems div img': {
      width: '20px',
      height: '20px',
    },

    '& .customHeaderMenuButton:first-of-type': {
      marginRight: '2px',
    },

    '& .customHeaderItems div': {
      height: '20px',
    },

    '& .customHeaderLabel': {
      width: '90%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      height: 'initial !important',
      marginRight: '7px',
      textAlign: 'left',
      fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
      fontWeight: '500',
      fontSize: '14px',
    },

    "& .agGridItemsColumnHeader div[class^='ag-react-container']": {
      width: '100%',
    },

    '& .agGridItemsColumnHeader .customHeaderItems': {
      justifyContent: 'flex-end',
      marginRight: '5px',
    },

    '& .agGridItemsColumnHeader .customHeaderLabel': {
      marginRight: 'auto',
    },

    '& .agGridItemsColumnHeader .customHeaderLabel:hover': {
      marginRight: 'auto',
      marginLeft: '8px',
    },

    '& .customHeaderMenuButtonList': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      opacity: 0,
      marginRight: '8px',
    },

    '& .customHeaderMenuButtonList-active': {
      display: 'flex',
      width: '10%',
      justifyContent: 'end',
      opacity: 1,
      marginRight: '8px',
    },

    '& .ag-icon-copy::before': {
      content: 'none',
    },

    '& .contextMenuExportExcelIcon span img': {
      width: '20.9px',
      height: '18.3px',
    },

    '& .ag-menu-option': {
      height: '36px',
    },

    '& .ag-menu-separator': {
      height: 0,
    },

    '& .ag-menu-list': {
      padding: 0,
    },

    '& .product-items-table-pinned-bottom-totals-row > div': {
      backgroundColor: '#f5f5f5 !important',
    },

    '& .background-banded-bundle-child': {
      backgroundColor: 'rgba(125, 56, 148, 0.08)',
    },
    '& .background-banded-bundle-child::after': {
      backgroundColor: 'rgba(125, 56, 148, 0.08)',
    },
    '& .background-banded-bundle-child-dark': {
      backgroundColor: 'rgba(197, 161, 212, 0.4)',
    },

    '& .background-banded-bundle-child-dark::after': {
      backgroundColor: 'rgba(197, 161, 212, 0.4)',
    },

    '& .product-items-table-pinned-bottom-totals-row > div:first-of-type > span::before': {
      content: '"Totals"',
      fontFamily: 'HP Simplified',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '143%',
      letterSpacing: '0.15px',
      color: '#000000',
    },
    '& input': {
      border: 'none',
      width: '100%',
      textAlign: 'right',
    },
    '& .ag-cell.ag-cell-inline-editing': {
      margin: '4px 0!important',
    },
    '& .ag-cell.ag-cell-inline-editing > .ag-react-container': {
      border: '1px solid #0096d6!important',
      boxShadow: '0 1px 5px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.24)!important',
      height: '100%',
      borderRadius: '4px',
    },
    '& input:focus-visible': {
      border: 'none',
      fontSize: '14px',
      outline: 'unset',
      padding: '0 6px!important',
    },
    "& input[type='checkbox']": {
      width: '18px',
      height: '18px',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      backgroundImage: 'url(/static/media/checkbox-checked-gray.5d5502e0.svg)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '24px 24px',
      backgroundPosition: '50% 50%',
    },
    '& .ag-cell.checkBoxAg': {
      border: 'none !important',
    },
    '& .custom-icon': {
      minWidth: '20px',
      width: '20px',
      height: '32px',
      backgroundPosition: '50% 50%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
      marginRight: '6px',
      '&.alert-blue': {
        backgroundImage: 'url(/assets/icons/alert-blue.svg)',
      },
    },
    '& .color-pink': {
      background: '#ffbdc9',
    },
    '& .color-green': {
      background: '#c3ffde',
    },
    '& .color-blue': {
      background: '#cceaf7',
    },
    '& .ag-cell.font-dimGray, .ag-cell.dimGray input': {
      color: '#8f8f8f',
    },
    '& .ag-cell.font-red': {
      color: '#d6002a',
    },
    '& .ag-cell.dimGray': {
      background: '#8f8f8f !important',
    },
    '& .ag-cell.limegreen': {
      background: '#00b04f66 !important',
    },
    '& .ag-cell.lightgreen': {
      background: '#c3ffde !important',
    },
    '& .ag-cell.lightpink': {
      background: '#ffbdc9 !important',
    },
    '& .ag-cell.lightyellow': {
      background: '#f8fab8 !important',
    },
    '& .ag-cell.whiteSmoke': {
      background: '#f5f5f5 !important',
    },
    '& .ag-cell.yellow': {
      background: 'rgb(255, 255, 102) !important',
    },
    '& .ag-row.grey-out-dark .ag-cell': {
      background: 'rgba(199, 199, 199, 1) !important',
      color: '#000000',
    },
    '& .ag-row. .ag-cell input': {
      color: '#9e9e9e',
    },
    '& .ag-row.grey-out .ag-cell': {
      background: 'rgba(199, 199, 199, 0.6) !important',
      color: '#000000',
    },
    '& .ag-row.grey-out .ag-cell input': {
      color: '#9e9e9e',
    },
    '& .ag-theme-alpine .ag-rich-select-list': {
      height: 'auto !important',
      maxHeight: '200px !important',
      overflow: 'auto',
    },
    '& .ag-theme-alpine .ag-rich-select': {
      backgroundColor: '#ffff !important',
    },
    '&.ag-theme-alpine .ag-ltr .ag-header-select-all': {
      zIndex: 5,
      marginLeft: '10px !important',
      marginRight: '3px !important',
    },
    '& .ag-cell.dropdown-cell': {
      border: 'none !important',
      marginLeft: '5px',
      textAlign: 'left',
    },
    '& .ag-theme-alpine .ag-rich-select-value': {
      height: '35px !important',
      borderBottom: 'solid 1px #c7c7c7 !important',
    },
    '& .ag-cell-label-container.dropdown-header': {
      flexDirection: 'unset',
    },
    '& .dropdown-container': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    '& .dropdown-value': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    '& .ag-popup .custom-tooltip': {
      position: 'absolute',
      opacity: 1,
      transition: 'opacity 1s',
      backgroundColor: 'rgba(97, 97, 97, 0.9)',
      color: 'white',
      fontSize: '14px',
      boxShadow: 'none',
      borderRadius: '4px',
      border: 'none',
      display: 'block',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '6px 10px',
      maxwidth: '50px',
      whitespace: 'preline',
    },
    '& .ag-popup .custom-tooltip.ag-tooltip-hiding': {
      opacity: 0,
    },
    '& .ag-popup .custom-tooltip .tooltip-text': {
      padding: '4px 10px',
      whitespace: 'preline',
      display: 'block',
      overflowWrap: 'break-word',
      maxwidth: '100%',
    },
    '& .ag-tooltip, & .custom-tooltip': {
      whiteSpace: 'pre-line',
      wordBreak: 'break-word',
      maxWidth: '50%',
    },

    '& .ag-row-hover': {
      backgroundColor: 'rgba(0, 150, 214, 0.04) !important',
      display: 'block',
    },

    '& .ag-row-selected': {
      backgroundColor: 'rgba(0, 150, 214, 0.08) !important',
    },

    '& .ag-theme-alpine .ag-checkbox-input-wrapper.ag-checked': {
      color: '#0096D6 !important',
    },
    '& .ag-checkbox-input-wrapper': {
      color: '#0096D6 !important',
      marginRight: '40px',
    },
    '& ag-checkbox-input': {
      color: '#0096D6 !important',
      marginRight: '30px',
    },
    '& .background-lightgreen': {
      background: 'rgba(195, 255, 222, 0.5) !important',
    },
    '& .background-lightgray': {
      background: 'rgba(245, 245, 245, 1)',
    },
  },
  searchFieldContainer: {
    border: '1px solid #e8e8e8',
    height: '42px',
    width: '400px',
    borderRadius: '7px',
    padding: '6px 8px 8px',
    background: '#fff',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    transition: 'border-color 0.2s ease-in-out',
    // Add focus styles
    '&:focus-within': {
      border: '2px solid #1976d2',
      outline: 'none',
    },
    // TextField focus styles
    '& .MuiInputBase-root': {
      '&.Mui-focused': {
        '& fieldset': {
          borderColor: 'transparent !important',
        },
      },
    },
    // Remove default TextField outline when focused
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-input': {
      '&:focus': {
        outline: 'none',
      },
    },
  },
  selectUserText: {
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    fontStyle: 'bold',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '150%',
    letterSpacing: '0.15px',
    color: '#7D3894',
    marginTop: '8px',
  },
  searchIconBlue: {
    color: '#1976d2',
    marginRight: '8px',
  },
  searchResultsDropdown: {
    boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
    border: '1px solid #e0e0e0',
    background: '#fff',
  },
  searchFieldFocused: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976d2 !important',
    },
  },
  searchTitle: {
    fontFamily: 'HP Simplified, Arial, sans-serif',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '150%',
    letterSpacing: '0.15px',
    color: '#7D3894',
  },
  employeeListItemText: {
    '& .MuiListItemText-primary': {
      fontFamily: 'HP Simplified, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '16px',
      lineHeight: '150%',
      letterSpacing: '0.15px',
    },
  },

  searchDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 10,
    marginTop: 2,
    borderRadius: 8,
    maxHeight: 180,
    overflowY: 'auto',
    boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
    border: '1px solid #e0e0e0',
    background: '#fff',
  },

  loadingDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 10,
    marginTop: 2,
    borderRadius: 8,
    maxHeight: 180,
    overflowY: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 0',
    boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
    border: '1px solid #e0e0e0',
    background: '#fff',
  },

  employeeListDivider: {
    margin: 0,
    border: 'none',
    borderBottom: '1px solid #e0e0e0',
  },

  alertContainer: {
    position: 'fixed',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
    width: '90%',
    maxWidth: '500px',
    padding: '0',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      maxWidth: '400px',
    },
  },

  alertOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 9998,
  },
  assignmentsTableContainer: {
    display: 'flex',
    flex: '1 1',
    flexDirection: 'column',
    padding: '19px 24px 24px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '19px 16px 16px',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    width: '100%',
  },
  assignToButton: {
    padding: '4px 10px',
    width: '160px',
    height: '40px',
    color: '#0096d6',
    fontSize: '14px',
    fontWeight: '400',
    letterSpacing: '0.4px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      padding: '2px 6px',
      width: '70px',
      height: '26px',
    },
  },
  saveAssignmentsButtonContainer: {
    padding: '6px 24px 20px 16px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
  },
}))
